import { ChevronRightIcon } from "lucide-react";
import { Disclosure, DisclosurePanel } from "react-aria-components";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { useWorkspace } from "./WorkspaceProvider";

export function WorkspaceSidebar() {
  const { activeTab, setActiveTab, activeDay, setActiveDay, workflow } =
    useWorkspace();

  // const activeStepIndex =
  //   workflow.steps.findLastIndex((step) => step.status === "COMPLETED") + 1;
  const activeStepIndex = 100;

  return (
    <Sidebar collapsible="none" className="relative">
      <SidebarContent className="bg-background border-r">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  isActive={activeTab === "overview"}
                  onPress={() => setActiveTab("overview")}
                >
                  Overview
                </SidebarMenuButton>
              </SidebarMenuItem>
              {workflow.instanceTemplate.steps.map((step, index) =>
                step.id === "OBSERVATION" ? (
                  <Disclosure key={step.id} defaultExpanded>
                    <SidebarMenuItem>
                      <SidebarMenuButton
                        slot="trigger"
                        isDisabled={activeStepIndex < index}
                      >
                        {step.title}
                      </SidebarMenuButton>
                      <DisclosurePanel id="observation-schedule">
                        <SidebarMenuSub>
                          {(
                            workflow.instanceTemplate.config
                              .observationSchedule as number[]
                          )?.map((day) => (
                            <SidebarMenuSubItem key={day}>
                              <SidebarMenuSubButton
                                isActive={day === activeDay}
                                onClick={() => {
                                  setActiveTab(step.id || "overview");
                                  setActiveDay(day);
                                }}
                                isDisabled={activeStepIndex < index}
                              >
                                Day {day}
                              </SidebarMenuSubButton>
                            </SidebarMenuSubItem>
                          ))}
                        </SidebarMenuSub>
                      </DisclosurePanel>
                    </SidebarMenuItem>
                  </Disclosure>
                ) : step.config?.repeat === "observationSchedule" ? (
                  <Disclosure
                    key={step.id}
                    defaultExpanded={activeStepIndex >= index}
                  >
                    <SidebarMenuItem>
                      <SidebarMenuButton slot="trigger">
                        {step.title}
                        <ChevronRightIcon />
                      </SidebarMenuButton>
                      <DisclosurePanel>
                        <SidebarMenuSub>
                          {(
                            workflow.instanceTemplate.config
                              .observationSchedule as number[]
                          )?.map((day) => (
                            <SidebarMenuSubItem key={day}>
                              <SidebarMenuSubButton
                                isActive={day === activeDay}
                                onClick={() => {
                                  setActiveTab(step.id || "overview");
                                  setActiveDay(day);
                                }}
                                isDisabled={activeStepIndex < index}
                              >
                                Day {day} {step.id}
                              </SidebarMenuSubButton>
                            </SidebarMenuSubItem>
                          ))}
                        </SidebarMenuSub>
                      </DisclosurePanel>
                    </SidebarMenuItem>
                  </Disclosure>
                ) : (
                  <SidebarMenuItem key={step.id}>
                    <SidebarMenuButton
                      isActive={activeTab === step.id}
                      onPress={() => setActiveTab(step.id || "overview")}
                      isDisabled={activeStepIndex < index}
                    >
                      {/* {step.status === "COMPLETED" ? (
                        <StatusFinalIcon />
                      ) : (
                        <StatusNewIcon />
                      )} */}
                      {step.title}
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ),
              )}
              {/* <SidebarMenuItem>
                <SidebarMenuButton
                  isActive={activeTab === "summary"}
                  onPress={() => setActiveTab("summary")}
                >
                  Summary
                </SidebarMenuButton>
              </SidebarMenuItem> */}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
